module.exports = __webpack_public_path__ + "img/gq3.d20865e9.png";